export default __webpack_public_path__ + "static/media/hattsoff.e464cf20.png";